import Constants from '../actions/types';
import { removeMilliseconds } from '../utils';

const initialState = {
  domains: [],
  loading: false,
  message: null,
  severity: null,
  selected: null
};

const identifierDomainsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.IDDOMAINS_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.IDDOMAINS_GET_SUCCESS: {
      const data = action.payload.map(value => removeMilliseconds(value));
      const newState = {
        ...state,
        domains: data,
        selected: data ? data[0] : null,
        loading: false
      };

      return newState;
    }

    case Constants.IDDOMAINS_GET_FAILURE: {
      const newState = {
        ...state,
        domains: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.IDDOMAINS_ADD_SUCCESS: {
      const newDomains = [...state.domains, action.payload];
      const newState = {
        ...state,
        domains: newDomains,
        loading: false,
        message: `Added domain ${action.payload.identifierDomainName} successfully.`,
        severity: 'info'
      };

      return newState;
    }

    case Constants.IDDOMAINS_SAVE_SUCCESS: {
      const selectedDomain = state.domains.find(
        domain =>
          domain.identifierDomainId === action.payload.identifierDomainId
      );
      const index = state.domains.indexOf(selectedDomain);
      const newDomains = [].concat(
        state.domains.slice(0, index),
        action.payload,
        state.domains.slice(index + 1)
      );
      const newState = {
        ...state,
        domains: newDomains,
        loading: false,
        message: `Saved domain ${selectedDomain.identifierDomainName} successfully.`,
        severity: 'info'
      };

      return newState;
    }

    case Constants.IDDOMAINS_DELETE_SUCCESS: {
      const selectedDomain = state.domains.find(
        domain =>
          domain.identifierDomainId === action.payload.identifierDomainId
      );
      const index = state.domains.indexOf(selectedDomain);
      const newDomains = [].concat(
        state.domains.slice(0, index),
        state.domains.slice(index + 1)
      );
      const newState = {
        ...state,
        domains: newDomains,
        loading: false,
        message: `Deleted domain ${selectedDomain.identifierDomainName} successfully.`,
        severity: 'info'
      };

      return newState;
    }

    case Constants.IDDOMAINS_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.IDDOMAINS_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default identifierDomainsReducer;
